import { Button } from '@mui/material';
import { COLORS } from '@/constants';
import styled from 'styled-components';

export const Container = styled.div<{ $isMap?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 20px;
  width: ${({ $isMap }) => ($isMap ? '100%' : '240px')};
  // position: sticky;
  // top: 44px;
`;

export const LeftMenuWrapper = styled.div<{ $isMap?: boolean }>`
  width: 240px;
  flex-shrink: 0;
  position: relative;

  ${({ $isMap }) =>
    $isMap &&
    `
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-gutter: stable;
    padding-right: 8px;
    box-sizing: border-box;
  `}

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const SearchProfileWrapper = styled.div`
  width: 100%;
`;

export const ResetButton = styled(Button)`
  && {
    width: 100%;
    height: 32px;
    background-color: ${COLORS['secondary/50']};
    color: ${COLORS['secondary/800']};
    border: none;
    font-weight: 600;
    font-size: 12px;
    gap: 6px;

    &:hover {
      background-color: ${COLORS['secondary/50']};
      border: none;
    }

    svg {
      width: 16px;
      height: 16px;
      color: ${COLORS['secondary/500']};
      flex-shrink: 0;
    }
  }
`;

export const StickyBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  padding: 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
`;
